(function (app) {
  $(document).ready(function () {
    app.imagesGetUrl = '/api/image/shared';
    app.ImageManager = function (options) {
      var _this = this;
      _this.options = $.extend({'imageSelection': 'single'}, options);

      var nameSpace = 'ImageManager' + _this.id,
        context = '.page__image_manager--context',
        templates = {
          'imageRow': app.templates["Image__manager____row"]
        },
        defaultPageParams = {
          'pageSize': 30,
          'pageNo': 1,
          'q': '',
          'byTags': '',
          'orderBy': 'dateCreated',
          'orderByOrder': "DESC",
        }
        ;

      _this.initModal = function () {
        _this.modal = $(app.templates["Image__manager____modal"]);
        $('body').append(_this.modal);

        _this.id = _this.modal.assignId();
        _this.$modal = $('#' + _this.id);

        if ($('[data-modal-image-manager-full-image]').length == 0) {
          _this.fullImageModal = $(app.templates["Image__manager____modal-full-image"]);
          $('body').append(_this.fullImageModal);
        }

        _this.fullImageModal = $('[data-modal-image-manager-full-image]');

        _this.setContainerHeight();

        _this.appImageTagList = new app.ImageTagList();
        _this.appImageTagList.autoCompleteTags();

        _this.massTagModal = $(app.templates["Image__manager____modal-tag-images"]);
        $('body').append(_this.massTagModal);

        _this.$massTagModal = $('#' + _this.massTagModal.assignId());

        _this.tagModal = $(app.templates["Image__manager____modal-tag-image"]);
        $('body').append(_this.tagModal);

        _this.$tagModal = $('#' + _this.tagModal.assignId());
        _this.images = {};
      };

      _this.destroyModal = function () {
        $('[data-modal-image-manager]').remove();
        $('[data-modal-image-manager-full-image]').remove();
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': _this.dataTable.attr('data-orderBy'),
          'orderByOrder': _this.dataTable.attr('data-orderByOrder')
        }, defaultPageParams);
      };

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.getContainerHeight = function() {
        return $(window).height() - $('.modal-header', _this.$modal).height() - $('.modal-footer', _this.$modal).height() - 100;
      };

      _this.setContainerHeight = function () {
        var height = _this.getContainerHeight();
        _this.$modal.find('.image-tags__list-container').height(height);
        _this.$modal.find('.grid__wrapper').height(height);
      };

      _this.destroy = function () {
        _this.destroyModal();
      };

      _this.initMasonry = function () {
        var $grid = $('.grid__container', _this.$modal).find('.grid__wrapper');
        if ($grid.length) {
          $grid.remove();
        }

        _this.wrapper = $('<div class="grid__wrapper m-progress"> </div>').prependTo($('.grid__container', _this.$modal)).height(_this.getContainerHeight());
        _this.dataTable = $('<div class="grid" > <div class="grid-sizer"></div> </div>').appendTo(_this.wrapper);
        _this.grid = _this.dataTable.masonry({
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
        });
      };

      _this.initInfiniteScroll = function () {
        var $paginationId = $('.pagination__next', _this.modal).attr('href', _this.buildUrl({pageNo: 2})).assignId();

        var $modalBody = $('.grid__wrapper', _this.$modal);

        if (_this.infiniteScroll) {
          _this.infiniteScroll.infiniteScroll('destroy');
        }

        _this.infiniteScroll = $modalBody.infiniteScroll({
          path: '#' + $paginationId,
          append: false,
          history: false,
          checkLastPage: false,
          elementScroll: true
        });

        _this.infiniteScroll.on('load.infiniteScroll', function (event, response, path) {
          _this.updateList(response);
          $('.grid__loader', _this.$modal).hide();
        });

        _this.infiniteScroll.on('request.infiniteScroll', function (event, path) {
          $('.grid__loader', _this.$modal).show();
        });
      };

      _this.uploaderLogs = function () {
        var logKey = '/api/image/user__POSTS';
        return {
          clear: function () {
            // Clear Logs
            window['__gites'][logKey] = [];
          },
          add: function (file) {
            // For Multiple uploads
            window['__gites'][logKey].push({
              'status': file.xhr.status,
              'response': file.xhr.response,
              'url': '/api/image/user'
            });
          },
          stats: function () {
            var success = [];
            var errors = [];
            _.each(window['__gites'][logKey], function (row) {
              if (row.status == 200) {
                success.push(row);
              } else {
                errors.push(row);
              }
            });

            if (success.length) {
              app.flashMessenger('success', success.length + ' File(s) Uploaded Successfully');
            }

            if (errors.length) {
              app.flashMessenger('error', errors.length + ' File(s) not uploaded, please mouse over file to see error');
            }
          }
        }
      };

      _this.init = function () {
        _this.initModal();
        _this.dataTable = _this.$modal.find('.grid');

        // Set Page Params to default or from storage
        _this.pageParams().set(_this.getDefaultPageParams());

        $(document) // Submit Action Search form
          .off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="image__list--search"]', function (e) {
            e.preventDefault();
            var $submitButton = $(this).find(':input[type=submit]');
            $submitButton.button('loading');

            var pageParams = {
              q: $(this).find(':input[name="q"]').val(),
              byTags: $(this).find(':input[name="byTags"]').val()
            };
            _this.pageParams().reset();
            _this.pageParams().set(pageParams);

            _this.initMasonry();
            _this.initInfiniteScroll();

            $.when(_this.get()).done(function (response) {
              $submitButton.button('reset');
            }).fail(function (response) {
              $submitButton.button('reset');
            });

          })// Actions :: favorite, unfavorite, add, remove
          .off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(e.target).closest('.image-tags__list-container').length) return;

            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              imageId = $dataRow.attr('data-row'),
              $context = $(context);

            var $formImageListSearch = $('form[name=image__list--search]', $context);
            var $btnListBackToGallery = $('.btn-list-back-to-gallery', $context);
            var $btnListManageTags = $('.btn-list-manage-tags', $context);
            var $btnListMy = $('.btn-list-my', $context);
            var $btnListFavorites = $('.btn-list-favorites', $context);
            var $btnUpload = $('[data-action="uploader"]', $context);
            var $gridContainer = $('.grid__container', $context);
            var $gridUpload = $('.grid__upload', $context);
            var $imageTagsListContainer = $('.image-tags__list-container', $context);
            var $btnSelectAll = $('.btn-select-all', $('.page__image_manager--container')).closest('.col');
            $formImageListSearch.css({'opacity': 1});

            switch (action) {
              case 'preview' :
                var imageRow = _.template(templates.imageRow);
                var previewData = {
                  'dimensions': $dataRow.find('img').attr('data-dimensions'),
                  'id': $dataRow.attr('data-row'),
                  'path': $dataRow.find('img').attr('data-url'),
                  'pathThumbnail': $dataRow.find('img').attr('data-url'),
                  'favorite': $dataRow.find('.btn-favorite').attr('data-action') == 'unfavorite',
                  'deletable': $dataRow.find('.btn-danger').length,
                  'selectable': _this.options['imageSelection'],
                };

                var $imageRow = $(
                  imageRow(
                    previewData
                  )
                );

                var $modalBody = _this.fullImageModal.find('.modal-body');
                $modalBody.html('');
                $imageRow.appendTo($modalBody);
                _this.fullImageModal.modal('show');
                app.lazyLoadImage(_this.fullImageModal);
                break;
              case 'delete' :
                $button.addClass('m-progress');
                $.when(_this.imageActions().delete(imageId)).done(function () {
                  $button.removeClass('m-progress');
                  var $image = $button.closest('.grid-item');
                  _this.grid.masonry('remove', $image).masonry('layout');
                  ;
                }).fail(function () {
                  $button.removeClass('m-progress');
                });
                break;

              case 'favorite' :
                $(this).attr('data-action', 'unfavorite');
                _this.markAsFavorite($(this));
                break;

              case 'unfavorite' :
                $(this).attr('data-action', 'favorite');
                _this.unMarkAsFavorite($(this));
                break;

              case 'select' :
                $(this).attr('data-action', 'unselect');
                _this.markAsSelected($(this));
                break;

              case 'unselect' :
                $(this).attr('data-action', 'select');
                _this.unMarkAsSelected($(this));
                break;

              case 'tag-select' :
                $(this).attr('data-action', 'tag-unselect');
                _this.markAsTagSelected($(this));
                break;

              case 'tag-unselect' :
                $(this).attr('data-action', 'tag-select');
                _this.unMarkAsTagSelected($(this));
                break;

              case 'uploader' :
                $(this).addClass('active');

                $formImageListSearch.css({'opacity': 0});

                $btnListBackToGallery.removeClass('d-none');

                $btnListManageTags.removeClass('active');
                $btnListFavorites.removeClass('active');
                $btnListMy.removeClass('active');

                $gridContainer.hide();
                $imageTagsListContainer.hide();
                $gridUpload.show();

                _this.uploaderLogs().clear();

                $(window).trigger('resize');
                break;

              case 'list-favorites':
                $(this).addClass('active');

                $btnListBackToGallery.removeClass('d-none');

                $btnListManageTags.removeClass('active');
                $btnListMy.removeClass('active');
                $btnUpload.removeClass('active');

                $gridUpload.hide();
                $imageTagsListContainer.hide();
                $gridContainer.show();

                app.imagesGetUrl = '/api/image/favorite';
                _this.pageParams().reset();
                _this.initMasonry();
                _this.initInfiniteScroll();

                $button.button('loading');
                $.when(_this.get()).done(function (response) {
                  $button.button('reset');
                }).fail(function (response) {
                  $button.button('reset');
                });

                $(window).trigger('resize');
                break;

              case 'list-all':
                $(this).removeClass('active');

                $btnListBackToGallery.addClass('d-none');

                $btnListManageTags.removeClass('active');
                $btnListFavorites.removeClass('active');
                $btnListMy.removeClass('active');
                $btnUpload.removeClass('active');

                $gridUpload.hide();
                $imageTagsListContainer.hide();
                $gridContainer.show();

                app.imagesGetUrl = '/api/image/shared';
                _this.pageParams().reset();
                _this.initMasonry();
                _this.initInfiniteScroll();

                $button.button('loading');
                $.when(_this.get()).done(function (response) {
                  $button.button('reset');
                }).fail(function (response) {
                  $button.button('reset');
                });
                $(window).trigger('resize');
                break;

              case 'list-my':
                $(this).addClass('active');

                $btnListBackToGallery.removeClass('d-none');

                $btnListManageTags.removeClass('active');
                $btnListFavorites.removeClass('active');
                $btnUpload.removeClass('active');

                $gridUpload.hide();
                $imageTagsListContainer.hide();
                $gridContainer.show();

                app.imagesGetUrl = '/api/image/user';
                _this.pageParams().reset();
                _this.initMasonry();
                _this.initInfiniteScroll();

                $button.button('loading');
                $.when(_this.get()).done(function (response) {
                  $button.button('reset');
                }).fail(function (response) {
                  $button.button('reset');
                });
                $(window).trigger('resize');
                break;


              case 'manage-tags':
                $(this).addClass('active');

                $formImageListSearch.css({'opacity': 0});

                $btnListBackToGallery.removeClass('d-none');

                $btnListFavorites.removeClass('active');
                $btnListMy.removeClass('active');
                $btnUpload.removeClass('active');

                $btnSelectAll.addClass('d-none');
                $gridContainer.hide();
                $gridUpload.hide();
                $imageTagsListContainer.show();

                var appImageTagList = new app.ImageTagList();
                appImageTagList.init();
                $(window).trigger('resize');
                break;

              case 'select-all' :
                $(this).addClass('active');
                $(this).attr('data-action', 'unselect-all');
                $(this).text('Unselect All');
                $('[data-action="tag-select"]', _this.$modal).trigger('click');
                break;

              case 'unselect-all' :
                $(this).removeClass('active');
                $(this).attr('data-action', 'select-all');
                $(this).text('Select All');
                $('[data-action="tag-unselect"]', _this.$modal).trigger('click');
                break;

              case 'insert' :
                if (_this.options.insertCallback) {
                  var $clonedImageContainer = $('.image__selected--container');
                  var imageUrls = _.map($clonedImageContainer.find('.image__item'), function (el) {
                    return {
                      'id': $(el).attr('data-id'),
                      'path': $(el).find('img').attr('data-url').replace(),
                      'pathThumbnail': $(el).find('img').attr('data-thumbnail'),
                      'dimensions': $(el).find('img').attr('data-dimensions'),
                    };
                  });
                  _this.options.insertCallback({images: imageUrls});
                }
                _this.$modal.modal('hide');
                break;


              case 'tag-image' :
                _this.$tagModal.modal('show');
                _this.$tagModal.find('.select2-container').remove();
                var $id = $(':input[name=id]', _this.$tagModal);
                $id.val(imageId);
                var $addRemoveSelect = $(':input[name="add-remove-tags"]', _this.$tagModal);
                $addRemoveSelect.find('option').remove();

                var tags = _.pluck(_this.images[imageId]['tags'], 'id').map(function(tag){
                  return parseInt(tag);
                });

                _.each(app.UserTags['result'], function (row) {
                  var $option = $('<option > </option>').appendTo($addRemoveSelect);
                  $option.text(row.tag);
                  $option.val(row.id);
                  $option.removeAttr('selected');
                  if (tags.indexOf(parseInt(row.id)) >= 0) {
                    $option.attr('selected', true);
                  }
                });

                /**
                 * Select 2 with tags
                 */
                $addRemoveSelect.select2({
                  theme: "bootstrap4",
                  tags: true,
                  placeholder: 'Add or remove tags',
                  dropdownParent: _this.$tagModal,
                }).on("select2:unselecting", function (e) {

                }).on("change.select2", function (e) {

                });

                break;

              case 'tag-images' :
                _this.$massTagModal.modal('show');

                var $ids = $(':input[name=ids]', _this.$massTagModal);
                var ids = [];
                $('.image__selected--container', $context).find('.image__item').each(function () {
                  ids.push($(this).data('id'));
                });
                $ids.val(ids);

                var $addSelect = $(':input[name=add-tags]', _this.$massTagModal);
                $addSelect.find('option').remove();
                _.each(app.UserTags['result'], function (row) {
                  var $option = $('<option > </option>').appendTo($addSelect);
                  $option.text(row.tag);
                  $option.val(row.id);
                });

                /**
                 * Select 2 with tags
                 */
                $addSelect.select2({
                  theme: "bootstrap4",
                  tags: true,
                  placeholder: 'Add tags',
                  dropdownParent: _this.$massTagModal,
                }).on("select2:unselecting", function (e) {

                }).on("change.select2", function (e) {

                });

                var $removeSelect = $(':input[name=remove-tags]', _this.$massTagModal);
                $removeSelect.find('option').remove();
                _.each(app.UserTags['result'], function (row) {
                  var $option = $('<option > </option>').appendTo($removeSelect);
                  $option.text(row.tag);
                  $option.val(row.id);
                });

                /**
                 * Select 2 with tags
                 */
                $removeSelect.select2({
                  theme: "bootstrap4",
                  placeholder: 'Remove tags',
                  dropdownParent: _this.$massTagModal,
                }).on("select2:unselecting", function (e) {

                }).on("change.select2", function (e) {

                });

                break;
            }

            var $clonedImageContainer, $imageItemsLength;


            if (action == 'select' || action == 'unselect') {
              $clonedImageContainer = $('.image__selected--container');
              $imageItemsLength = $clonedImageContainer.find('.image__item').length;

              if ($imageItemsLength) {
                $('.btn-insert-image').show();
              } else {
                $('.btn-insert-image').hide();
              }
            }


            if (action == 'tag-select' || action == 'tag-unselect') {
              $clonedImageContainer = $('.image__selected--container');
              $imageItemsLength = $clonedImageContainer.find('.image__item').length;

              if ($imageItemsLength) {
                $('.btn-tag-image').show();
              } else {
                $('.btn-tag-image').hide();
              }
            }

          }) // Selected image events
          .off('click.selected__' + nameSpace).on('click.selected__' + nameSpace, context + ' .image__selected--container .image__item', function (e) {
            var dataId = $(this).attr('data-id');
            var $dataRow = _this.dataTable.find('[data-row=' + dataId + ']').find('.image__item');
            $('.grid__wrapper', $(context)).scrollTo($dataRow, {
              duration: 800, offset: {'top': -100}, onAfter: function () {
                $dataRow.addClass('highlight');
                setTimeout(function () {
                  $dataRow.removeClass('highlight');
                }, 4000);
              }
            });
          }) // Submit Mass Tag Add Delete
          .off('submit.mass-tag-images__' + nameSpace).on('submit.mass-tag-images__' + nameSpace, 'form[name="form-tag-images"]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $submitButton = $this.find('button[type=submit]');
            $submitButton.button('loading');
            $.when(_this.imageActions().tag().massAddDelete()).done(function (response) {
              $submitButton.button('reset');
              _this.$massTagModal.modal('hide');
            }).fail(function (response) {
              $submitButton.button('reset');
            });
          }) // Submit tag add delete
          .off('submit.tag-image__' + nameSpace).on('submit.tag-image__' + nameSpace, 'form[name="form-tag-image"]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $submitButton = $this.find('button[type=submit]');
            $submitButton.button('loading');
            $.when(_this.imageActions().tag().addDelete()).done(function (response) {
              $submitButton.button('reset');
              _this.$tagModal.modal('hide');
            }).fail(function (response) {
              $submitButton.button('reset');
            });
          });

        $(window).off('resize.' + nameSpace).on('resize.' + nameSpace, function () {
          _this.setContainerHeight();
        });

        // Modal On show Hide
        _this.$modal.on('shown.bs.modal', function (e) {
          _this.initMasonry();
          _this.initInfiniteScroll();

          app.imagesGetUrl = '/api/image/shared';
          _this.pageParams().reset();

          $.when(_this.get()).done(function (response) {
          }).fail(function (response) {
          });

          $('[data-dropzone]', _this.$modal)
            .dropzone({
              acceptedFiles: 'image/jpg, image/jpeg, image/png, image/gif',
              url: "/api/image/user",
              maxFilesize: 10, // MB,
              timeout: 0,
              parallelUploads: 1,
              complete: function (file) {
                // Only used for GI
                var logKey = '/api/image/user__POST';
                window['__gites'][logKey] = {
                  'status': file.xhr.status,
                  'response': file.xhr.response,
                  'url': '/api/image/user'
                };

                _this.uploaderLogs().add(file);
              },
              queuecomplete: function (e) {
                _this.uploaderLogs().stats();
              },
              sending: function (file, xhr, formData) {

              }
            });
        }).on('hidden.bs.modal', function (e) {
          _this.destroy();
          $('.modal-backdrop').remove();
          if (_this.options.hiddenCallback) {
            _this.options.hiddenCallback();
          }
        });

        _this.$modal.modal('show');

      };

      _this.buildUrl = function (options) {
        options = $.extend({}, _this.pageParams().get(), options);

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.byTags) ? queryBuilders.push('byTags=' + options.byTags) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.query) ? queryBuilders.push('query=' + options.query + '&' + $.param(options.queryParams)) : '';

        return app.imagesGetUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.imageActions = function () {
        return {
          delete: function (imageId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_.isEmpty(response)) {
                  app.flashMessenger('error', 'Empty response');
                  return query.reject(response);
                } else {
                  app.flashMessenger('success', response.message);
                  return query.resolve(response);
                }
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/image/user/' + imageId);
            return query.promise();
          },
          favorite: function (imageId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_.isEmpty(response)) {
                  app.flashMessenger('error', 'Empty response');
                  return query.reject(response);
                } else {
                  app.flashMessenger('success', response.message);
                  return query.resolve(response);
                }
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.post('/api/image/favorite/' + imageId);
            return query.promise();
          },
          unfavorite: function (imageId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_.isEmpty(response)) {
                  app.flashMessenger('error', 'Empty response');
                  return query.reject(response);
                } else {
                  app.flashMessenger('success', response.message);
                  return query.resolve(response);
                }
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/image/favorite/' + imageId);
            return query.promise();
          },

          tag: function () {
            return {
              addDelete: function () {
                var query = $.Deferred();
                var $form = $('form[name="form-tag-image"]', _this.$tagModal);
                var appTransport = app.transport();
                var formData = $form.serializeObject();
                var imageId = formData.id;
                var requestData = {};
                requestData.tags = [];
                $form.find(':input[name=add-remove-tags]').find(':selected').each(function () {
                  requestData.tags.push(this.text);
                });

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    _this.appImageTagList.autoCompleteTags();
                    app.flashMessenger('success', response.message);
                    var result = response.result[0];
                    _this.images[result.id] = {'tags' : result.tags};
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  });

                appTransport.post('/api/image/tag/' + imageId);
                return query.promise();
              },
              massAddDelete: function () {
                var query = $.Deferred();
                var $form = $('form[name="form-tag-images"]', _this.$massTagModal);
                var appTransport = app.transport();
                var formData = $form.serializeObject();
                var requestData = {};
                requestData.ids = formData.ids;
                requestData.addTags = [];
                requestData.removeTags = [];
                $form.find(':input[name=add-tags]').find(':selected').each(function () {
                  requestData.addTags.push(this.text);
                });

                $form.find(':input[name=remove-tags]').find(':selected').each(function () {
                  requestData.removeTags.push(this.value);
                });

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    _this.appImageTagList.autoCompleteTags();
                    app.flashMessenger('success', response.message);
                    _.each(response.result, function(row){
                      _this.images[row.id] = {'tags' : row.tags};
                    });
                    $('[data-action="tag-unselect"]', _this.$modal).trigger('click');
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;

                appTransport.post('/api/image/tag');
                return query.promise();
              }
            }
          }
        }
      };

      // To update Table view
      _this.updateList = function (response) {

        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            var imageRow = _.template(templates.imageRow);

            var $imageRow = $(
              imageRow(
                $.extend(row, {
                  selectable: _this.options['imageSelection'],
                  deletable: _.isUndefined(row.deletable) ? false : row.deletable,
                  favorite: _.isUndefined(row.favorite) ? false : row.favorite
                })
              )
            );
            $imageRow.appendTo(_this.dataTable);
            _this.grid.append($imageRow).masonry('appended', $imageRow);
            _this.images[row.id] = {'tags': row.tags};
          });
        } else {
          if ($('.grid-item', _this.$modal).length == 0) {
            $('.grid__no-result', _this.$modal).show();
          }
        }
        app.lazyLoadImage(_this.dataTable, function (element) {
          _this.grid.masonry('layout');
          element.parent().find('.image__actions').addClass('show');
        }, function () {
          setTimeout(function () {
            _this.grid.masonry('layout');
          }, 1000);
        });
      };

      /**
       * Mark as favorite
       * @param el
       */
      _this.markAsFavorite = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        el.addClass('m-progress');
        $.when(_this.imageActions().favorite(dataId)).done(function () {
          $dataRow.find('.btn-favorite i').addClass('fas').removeClass('fab');
          el.removeClass('m-progress');
        }).fail(function () {
          el.removeClass('m-progress');
        });
      };

      /**
       * UnMark as favorite
       * @param el
       */
      _this.unMarkAsFavorite = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        el.addClass('m-progress');
        $.when(_this.imageActions().unfavorite(dataId)).done(function () {
          $dataRow.find('.btn-favorite i').addClass('fab').removeClass('fas');
          el.removeClass('m-progress');
        }).fail(function () {
          el.removeClass('m-progress');
        });
      };

      /**
       * Mark as Selected for tagging
       * @param el
       */
      _this.markAsTagSelected = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        var $clonedImageContainer = $('.image__selected--container');

        $dataRow.addClass('tag-selected');
        var $btn = $dataRow.find('.btn-tag-select');
        $btn.addClass('checked');
        $btn.find('i').addClass('fa-check').removeClass('fa-square');

        // Clone and append to image__selected--container
        var $cloneDataRow = $dataRow.find('.image__item').clone();
        $cloneDataRow.removeAttr('data-action');
        $cloneDataRow.appendTo($clonedImageContainer);

      };

      /**
       * UnMark as Selected for tagging
       * @param el
       */
      _this.unMarkAsTagSelected = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        $dataRow.removeClass('tag-selected');
        var $btn = $dataRow.find('.btn-tag-select');
        $btn.removeClass('checked');
        $btn.find('i').removeClass('fa-check').addClass('fa-square');

        var $clonedImageContainer = $('.image__selected--container');
        $clonedImageContainer.find('[data-id=' + dataId + ']').remove();

      };

      /**
       * Mark as added
       * @param el
       */
      _this.markAsSelected = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        var $clonedImageContainer = $('.image__selected--container');

        if (_this.options['imageSelection'] == 'single') {
          _this.unMarkAsSelected($('[data-row].selected'));
        }

        $dataRow.addClass('selected');
        var $btn = $dataRow.find('.btn-select');
        $btn.addClass('checked');
        $btn.find('i').addClass('fa-check').removeClass('fa-plus-circle');

        // Clone and append to image__selected--container
        var $cloneDataRow = $dataRow.find('.image__item').clone();
        $cloneDataRow.removeAttr('data-action');
        $cloneDataRow.appendTo($clonedImageContainer);

      };

      _this.unMarkAsSelected = function (el) {
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row')
          ;
        $dataRow.removeClass('selected');
        var $btn = $dataRow.find('.btn-select');
        $btn.removeClass('checked');
        $btn.find('i').removeClass('fa-check').addClass('fa-plus-circle');

        var $clonedImageContainer = $('.image__selected--container');
        $clonedImageContainer.find('[data-id=' + dataId + ']').remove();

      };

      _this.get = function (options) {
        $('.grid__no-result', _this.$modal).hide();
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.wrapper.removeClass('m-progress');
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            //_this.updateList(_this.fakeImages());
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.resolve(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };


      return {
        show: function () {
          _this.init();
        }
      };
    };
  });
})(PreBuilt);
